import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, MediaWrapper, InfoWrapper } from './styles';

const Card = ({ media, description, isMobile, isMap }) => {
  return (
    <Wrapper isMobile={isMobile} isMap={isMap}>
      <MediaWrapper isMobile={isMobile}>{media}</MediaWrapper>
      <InfoWrapper isMobile={isMobile}>{description}</InfoWrapper>
    </Wrapper>
  );
};

Card.propTypes = {
  description: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  media: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  isMobile: PropTypes.bool,
  isMap: PropTypes.bool
};

export default Card;
